var t = "_overlay_pdaq7_1",
  n = "_container_pdaq7_11",
  a = "_containerBig_pdaq7_26",
  e = "_title_pdaq7_31",
  o = {
    overlay: t,
    container: n,
    containerBig: a,
    title: e
  };
export { n as container, a as containerBig, o as default, t as overlay, e as title };